import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import Comparison from './Comparison.vue'
import AppHeaderWithMenu from '../../components/layout/AppHeaderWithMenu'
// import AppSidebar from '../../components/layout/AppSidebar'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/comparison/:raceId',
      name: 'comparison',
      components: {
        default: Comparison,
        header: AppHeaderWithMenu,
      },
      beforeEnter: allowOnlyAuthorized()
    }
  ])
}
